import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { baseApi } from "./apis";
import { magicoApi } from "./apis/magicoApi";
import appConfigSlice from "./slices/appConfig";
import authSlice from "./slices/auth";
import authErrorSlice from "./slices/authError";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    authError: authErrorSlice,
    appConfig: appConfigSlice,
    [baseApi.reducerPath]: baseApi.reducer,
    [magicoApi.reducerPath]: magicoApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, magicoApi.middleware),
});

// Enable refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
